import { PropsWithChildren, useEffect, useRef } from 'react'
import { useRecoilState } from 'recoil'
import authAtom from './auth.atom'
import useHttpLoader from '../../hooks/useHttpLoader'
import authApi from './auth.api'
import LoadScreen from '../../shared/Loaders/LoadScreen'
import AuthPage from './components/AuthPage'
import { applyInterceptors } from '../../shared/http'

const AuthProvider = (props: PropsWithChildren) => {
  const { wait, loading } = useHttpLoader()

  const [authState, setAuthState] = useRecoilState(authAtom)
  const refState = useRef({ ...authState })

  useEffect(() => {
    refState.current = { ...authState }
  }, [authState])

  useEffect(() => {
    applyInterceptors(refState, setAuthState)
    const refresh = localStorage.getItem('refresh')

    if (refresh) {
      refState.current.refreshToken = refresh

      wait(authApi.refreshToken(refresh), (resp) => {
        setAuthState((prev) => ({ ...prev, ...resp }))
        refState.current.accessToken = resp.accessToken
        refState.current.accessExpires = resp.accessExpires
      })
    }
  }, [])

  if (loading) {
    return <LoadScreen />
  }

  if (!authState.accessToken) {
    return <AuthPage />
  }

  return <>{props.children}</>
}

export default AuthProvider
